import moment from 'moment'

export const buildCommunityYearRangeFunctions = (createdAt) => {
  const currentYear = moment().year()
  const createdMoment = moment(createdAt)
  const createdYear = createdMoment.year()
  const firstYear = Math.min(currentYear, createdYear)

  const years = Array.from(
    { length: currentYear - firstYear + 1 },
    (_, i) => currentYear - i
  )

  // Returns { tKey, values } for the consumer to t(); see FiltersButtonDropdown for the pattern.
  const labelForYear = (year) => {
    if (year === currentYear) { return { tKey: 'dashboard.coach.communityYearRange.thisYear', values: { year } } }
    if (year === currentYear - 1) { return { tKey: 'dashboard.coach.communityYearRange.lastYear', values: { year } } }
    return { tKey: 'dashboard.coach.communityYearRange.yearOnly', values: { year } }
  }

  return Object.fromEntries(
    years.map((year) => [year, {
      textFunc: () => labelForYear(year),
      valueFunc: () => {
        const startOfYear = moment().year(year).startOf('year')
        const endOfYear = moment().year(year).endOf('year')

        const startDate = year === createdYear && createdMoment.isAfter(startOfYear)
          ? createdMoment.clone().toDate()
          : startOfYear.toDate()

        return { startDate, endDate: endOfYear.toDate() }
      },
    }])
  )
}
